import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from "../BaseApi";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 28 de 01 de 2026
 */

const UserPreferencesSlice = createSlice({
    name: 'userPreferencesService',
    initialState: {
        getUserPreferencesByUserId:[]
    },
    reducers: {},
    extraReducers: {
        'userPreferencesService/getUserPreferencesByUserId/fulfilled': (state, action) => {
            state.getUserPreferencesByUserId = ResponseApi(action.payload);
        },
    },
});

export const {} = UserPreferencesSlice.actions;

export default UserPreferencesSlice.reducer;
